import React, {FC} from 'react'
import {PageTitle} from '../../../_metronic/layout/core'
import {useIntl} from "react-intl";
import TaxGroup from './TaxGroup';

const TaxGroupWrapper: FC = () => {

  const intl = useIntl();
  const breadcrumbs = [
    {
      title: intl.formatMessage({id: 'MENU.DASHBOARD'}),
      path: '/dashboard',
      isActive: true,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    }
  ]

  return (
    <>
      <PageTitle breadcrumbs={breadcrumbs}>Nhóm ngành</PageTitle>
      <TaxGroup />
    </>
  )
}

export default TaxGroupWrapper
